import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from "../../../SpecialtyPersonalStyles.module.scss"
import metadata from './SolidFuelHeatingComponent.metadata.json5';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function SolidFuelHeatingComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('SolidFuelHeatingComponent');

    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true

    const stoveContainerVisible = () => {
        if(submissionVM.lobData.perLine.coverables.mobileHomeCoverable.mobileHomes.value[0].propertyDetails.istheastoFie === true) {
            return true
        }

        return false
    }

    const chimneyContainerVisible = () => {
        if(submissionVM.lobData.perLine.coverables.mobileHomeCoverable.mobileHomes.value[0].propertyDetails.istheachiFie === true) {
            return true
        }

        return false
    }

    const fluePipeContainerVisible = () => {
        if(submissionVM.lobData.perLine.coverables.mobileHomeCoverable.mobileHomes.value[0].propertyDetails.istheaflupipFie === true) {
            return true
        }

        return false
    }

    const solidFuelHeatingVisible = () => {
        if(submissionVM.lobData.perLine.coverables.mobileHomeCoverable.mobileHomes.value[0].utilities.priHeaFueTypFie === 'Wood'
            || submissionVM.lobData.perLine.coverables.mobileHomeCoverable.mobileHomes.value[0].utilities.auxHeaFueTypFie === 'Wood'
        ) {
            return true
        }

        return false
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        StoveContainer: {       
            visible: solidFuelHeatingVisible()
        },
        whakinofsoudoyouusiasFie: {
            visible: solidFuelHeatingVisible()
        },
        typofStoFie: {
            visible: solidFuelHeatingVisible()
        },
        stoCerFie: {
            visible: solidFuelHeatingVisible()
        },
        yeaofManFie: {
            visible: solidFuelHeatingVisible()
        },
        stoManFie: {
            visible: solidFuelHeatingVisible()
        },
        stoModFie: {
            visible: solidFuelHeatingVisible()
        },
        istheatlea18incclematFie: {
            visible: solidFuelHeatingVisible()
        },
        isthefloshiextatlesidFie: {
            visible: solidFuelHeatingVisible()
        },
        thefloconsupthestooisFie: {
            visible: solidFuelHeatingVisible()
        },
        ifOthDesFie2: {
            visible: solidFuelHeatingVisible() && _.get(modelVM, 'thefloconsupthestooisFie.value.code') === "Other"
        },
        ChimneyContainer: {
            visible: solidFuelHeatingVisible()
        },
        istheChiFacbuiFie: {
            visible: solidFuelHeatingVisible()
        },
        pledesFie: {
            visible: solidFuelHeatingVisible()
        },
        whoinsFie: {
            visible: solidFuelHeatingVisible()
        },
        ifametchiistheatlematFie: {
            visible: solidFuelHeatingVisible()
        },
        doetheappshachiwitappFie: {
            visible: solidFuelHeatingVisible()
        },
        isthechiprocleannFie: {
            visible: solidFuelHeatingVisible()
        },
        ifnohowoftFie: {
            visible: solidFuelHeatingVisible() && _.get(modelVM, 'isthechiprocleannFie.value') === false
        },
        FluePipeContainer: {
            visible: solidFuelHeatingVisible()
        },
        istheatlea18incbetmatFie: {
            visible: solidFuelHeatingVisible()
        },
        istheametthiatlea1diaFie: {
            visible: solidFuelHeatingVisible()
        },
        howoftarethepipcleFie: {
            visible: solidFuelHeatingVisible()
        },
        ifOthDesFie5: {
            visible: solidFuelHeatingVisible() && _.get(modelVM, 'howoftarethepipcleFie.value.code') === "Other"
        }

    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

SolidFuelHeatingComponent.propTypes = wizardProps;
export default withRouter(SolidFuelHeatingComponent);